function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.584 6.84237L19.2903 4.77711C19.1424 4.63235 18.965 4.51654 18.7482 4.40074L11.7891 0.52114C11.1878 0.183364 10.5865 0 10.0049 0C9.4135 0 8.81222 0.183364 8.21094 0.52114L6.20996 1.63097L15.584 6.84237ZM10.0049 9.94026L14.2139 7.60478L4.87925 2.38373L1.26171 4.40074C1.04485 4.51654 0.867422 4.63235 0.709709 4.77711L10.0049 9.94026ZM10.6752 21C10.7442 20.9807 10.8034 20.9517 10.8724 20.9131L18.5904 16.6089C19.5071 16.0974 20 15.5763 20 14.1769V6.65901C20 6.36949 19.9803 6.13787 19.9211 5.92555L10.6752 11.0983V21ZM9.32479 21V11.0983L0.0788566 5.92555C0.0197141 6.13787 0 6.36949 0 6.65901V14.1769C0 15.5763 0.502711 16.0974 1.40956 16.6089L9.13751 20.9131C9.19665 20.9517 9.25579 20.9807 9.32479 21Z",
  fill: "#908CA0"
});

function SvgIconProductsNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductsNav);
export default __webpack_public_path__ + "static/media/icon-products-nav.b5dd3568.svg";
export { ForwardRef as ReactComponent };